import React from "react";

const TimePicker = ({ value, onChange }) => {
  let [hour, minute, meridiem] = value.split(/[: ]/);

  const handleInput = (type, val) => {
    if (type === "hour") {
      val = Math.max(1, Math.min(12, parseInt(val) || 1))
        .toString()
        .padStart(2, "0");
      hour = val;
    } else if (type === "minute") {
      val = Math.max(0, Math.min(59, parseInt(val) || 0))
        .toString()
        .padStart(2, "0");
      minute = val;
    } else if (type === "meridiem") {
      meridiem = meridiem === "AM" ? "PM" : "AM";
    }

    onChange(`${hour}:${minute} ${meridiem}`);
  };

  return (
    <div className="time-picker">
      <input
        type="number"
        value={hour}
        onChange={(e) => handleInput("hour", e.target.value)}
        min="1"
        max="12"
        className="time-input"
      />
      <span className="colon">:</span>
      <input
        type="number"
        value={minute}
        onChange={(e) => handleInput("minute", e.target.value)}
        min="0"
        max="59"
        className="time-input minute-input"
      />
      <div className="meridiem-toggle" onClick={() => handleInput("meridiem")}>
        <div className={`meridiem ${meridiem === "AM" ? "active" : ""}`}>
          AM
        </div>
        <div className={`meridiem ${meridiem === "PM" ? "active" : ""}`}>
          PM
        </div>
      </div>
    </div>
  );
};

const CustomTimeRangePicker = ({
  startTime,
  endTime,
  onStartChange,
  onEndChange,
  className = "",
}) => {
  return (
    <div className={`time-range-container ${className}`}>
      <TimePicker value={startTime} onChange={onStartChange} />
      <span className="to-label">to</span>
      <TimePicker value={endTime} onChange={onEndChange} />
    </div>
  );
};

export default CustomTimeRangePicker;
